import { styled } from '@mui/material/styles';

import Button from '@mui/material/Button';

const StyledButton = styled(Button)(({ theme, size, color, variant }) => ({
    height: size === 'medium' ? 40 : null,
    borderRadius: size === 'small' ? 6 : null,
    boxShadow: 'none',
    '&:hover': {
        boxShadow: 'none',
    },
    '&.MuiButton-contained:hover': {
        backgroundColor: theme.palette[color] ? theme.palette[color].hover : null,
    },
    '&.MuiButton-outlined': {
        color: theme.palette.secondary.contrastText,
        borderColor: theme.palette.border.main,
    },
    '&.MuiButton-outlined:hover': {
        backgroundColor: theme.palette.secondary.hover,
    },
    '&.Mui-disabled': {
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.border.main
    }
}));

export default StyledButton;
